import router from '@/router'
import { routes } from '@/router'
import store from '@/store'

routes.forEach(route => {
    if (route.children) {
      let childs_name = route.children.filter(child=> {
         return child.meta && child.meta.keepAlive
       }).map(child=>(child.name))
       store.dispatch('keepAlive/addCachedView', childs_name)
     } else if (route.meta && route.meta.keepAlive && route.name) {
       store.dispatch('keepAlive/addCachedView', route.name)
     }
});


router.beforeEach( async (to, from, next)=> {
    //将路由标题修改到页面顶部
    document.title = to.meta.title; 

    next();
  });
  
  router.afterEach((to, from, next) => {
    // 跳转后返回顶部
    // window.scrollTo(0, 0);
  })